import type { JSX } from 'react'
import React from 'react'
import delay from 'delay'
import TransitionOpacity from '../TransitionOpacity'
import { TimedNotificationPropsInterface, TimedNotificationStateInterface, Status } from './types'

class TimedNotification extends React.Component<TimedNotificationPropsInterface, TimedNotificationStateInterface> {

  _mounted
  state = {
    status: Status.NONE
  }

  componentDidMount () {

    this._mounted = true
    this.setupComponent()

  }

  componentDidUpdate (prevProps, prevState) {

    const hasPropsChanged = (...props: string[]): boolean =>
      props.some(prop => prevProps[prop] !== this.props[prop])
    const hasStateChanged = (...props: string[]): boolean =>
      props.some(prop => prevState[prop] !== this.state[prop])

    if (hasPropsChanged('content', 'onComplete', 'secsEaseIn', 'secsDisplay', 'secsEaseOut', 'children')) {

      this.setupComponent()

    }

    if (hasStateChanged('status')) {

      if (
        this.state.status === Status.DISPLAY ||
        this.state.status === Status.COMPLETE
      ) this.handleState()

    }

  }

  UNSAFE_componentWillMount () {

    this._mounted = false

  }

  componentWillUnmount () {

    this._mounted = false

  }

  setupComponent = () => {

    if (!this._mounted) return
    if ((this.props.secsEaseIn || 0) > 0) this.setState({ status: Status.EASE_IN })
    else this.setState({ status: Status.DISPLAY })

  }

  checkProps (props) {

    if (typeof props.content === 'undefined' && typeof props.children === 'undefined') return false
    const { secsEaseIn = 0, secsDisplay = 0, secsEaseOut = 0 } = props
    if (secsEaseIn === 0 && secsDisplay === 0 && secsEaseOut === 0) return false

    return true

  }

  handleState = async () => {

    switch (this.state.status) {

      case Status.EASE_IN:

        if (!this._mounted) return
        return this.setState({
          status: ((this.props.secsDisplay || 0) > 0)
            ? Status.DISPLAY
            : Status.EASE_OUT
        })

      case Status.DISPLAY:

        await delay((this.props.secsDisplay || 0) * 1000)
        if (!this._mounted) return
        return this.setState({
          status: ((this.props.secsEaseOut || 0) > 0)
            ? Status.EASE_OUT
            : Status.COMPLETE
        })

      case Status.EASE_OUT:

        if (!this._mounted) return
        return this.setState({ status: Status.COMPLETE })

      case Status.COMPLETE:

        if (this.props.onComplete) this.props.onComplete()
        if (this._mounted) this.setState({ status: Status.NONE })
        break

      default:
        break

    }

  }

  getComponent = (): JSX.Element => {

    switch (this.state.status) {

      case Status.EASE_IN:
        return <TransitionOpacity
          opacity={{ from: 0, to: 1 }}
          duration={this.props.secsEaseIn || 0}
          onComplete={this.handleState}
        >
          {this.props.content || this.props.children}
        </TransitionOpacity>
      case Status.DISPLAY:
        return <div>{this.props.content || this.props.children}</div>
      case Status.EASE_OUT:
        return <TransitionOpacity
          opacity={{ from: 1, to: 0 }}
          duration={this.props.secsEaseOut || 0}
          onComplete={this.handleState}
        >
          {this.props.content || this.props.children}
        </TransitionOpacity>
      default:
        return <div />

    }

  }

  render () {

    if (!this.checkProps(this.props)) return null

    return <div>{this.getComponent()}</div>

  }

}

export default TimedNotification
